<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 11.5L11.5 1M1 1L11.5 11.5" stroke="#121F3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
